{
  "id": "campaign-044",
  "name": "Unkempt Paddock",
  "seed": "campaign:44",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRR,,,,,,,,",
    "RRRR,,,,,,,,",
    "____,,,,,,,,",
    ",,,,,,,...,,",
    ",y,y,,..y.y,",
    ",,,,,,~....,",
    ",,y,,~~~.y.,",
    ",,,,,,,...,,",
    "ff,,ffffffff",
    ",,,,,,,,~,,,",
    ",,,,...~~,,,",
    ",,,,...,~,,,",
    ",,,,.,...,,,",
    ",,,......#..",
    ",,,....#...S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 8,
      "y": 6
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 14
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "rare",
      "x": 0,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 44,
  "biome": "farm",
  "par": {
    "reel": 13932,
    "push": 8474,
    "selfPropelled": 7776,
    "tractor": 4628,
    "zeroTurn": 5507,
    "fairway": 3013
  },
  "routeTries": {
    "par": {
      "reel": 16,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 20,
      "zeroTurn": 17,
      "fairway": 15
    }
  }
}
